import { useLocation } from "react-router-dom";
import Seo from "@/components/Seo";

type Meta = { title: string; description: string; noindex?: boolean };

const ROUTES: Record<string, Meta> = {
  "/": {
    title: "Torflash – Automatische Instagram Stories für deinen Fußballverein",
    description:
      "Spielankündigung, Tor-Alarm und Endstand als fertige Instagram-Story – automatisch, in eurem Vereinsdesign. Ohne Design-Kenntnisse. 14 Tage kostenlos testen.",
  },
  "/registrieren": {
    title: "Verein anmelden: Torflash in 5 Minuten eingerichtet",
    description:
      "Verein aus der BFV-Datenbank wählen, Logo und Farben festlegen, Design aussuchen – fertig. 14 Tage kostenlos, monatlich kündbar.",
  },
  "/signup": {
    title: "Verein anmelden: Torflash in 5 Minuten eingerichtet",
    description:
      "Verein aus der BFV-Datenbank wählen, Logo und Farben festlegen, Design aussuchen – fertig. 14 Tage kostenlos, monatlich kündbar.",
  },
  "/anmelden": {
    title: "Anmelden bei Torflash",
    description: "Melde dich an, um dein Vereinsprofil, Design und Abo bei Torflash zu verwalten.",
  },
  "/login": {
    title: "Anmelden bei Torflash",
    description: "Melde dich an, um dein Vereinsprofil, Design und Abo bei Torflash zu verwalten.",
  },
  "/impressum": {
    title: "Impressum: Torflash",
    description: "Anbieterkennzeichnung und Kontaktangaben gemäß § 5 TMG für Torflash.",
  },
  "/datenschutz": {
    title: "Datenschutzerklärung: Torflash",
    description: "Informationen zur Verarbeitung personenbezogener Daten bei der Nutzung von Torflash.",
  },
  "/agb": {
    title: "AGB: Allgemeine Geschäftsbedingungen von Torflash",
    description: "Vertragsbedingungen, Laufzeit, Preise und Kündigung für die Nutzung von Torflash.",
  },
  "/dashboard": {
    title: "Mein Verein: Torflash Dashboard",
    description: "Vereinsprofil, Design, Telegram-Verbindung und Abo verwalten.",
    noindex: true,
  },
  "/mein-verein": {
    title: "Mein Verein: Torflash Dashboard",
    description: "Vereinsprofil, Design, Telegram-Verbindung und Abo verwalten.",
    noindex: true,
  },
  "/checkout": {
    title: "Abo abschließen: Torflash",
    description: "Paket auswählen und Abo abschließen. 14 Tage kostenlos, monatlich kündbar.",
    noindex: true,
  },
  "/checkout/return": {
    title: "Bestellung abgeschlossen: Torflash",
    description: "Bestätigung deiner Torflash-Bestellung.",
    noindex: true,
  },
};

const FALLBACK: Meta = {
  title: "Seite nicht gefunden: Torflash",
  description: "Diese Seite existiert nicht. Zurück zur Startseite von Torflash.",
  noindex: true,
};

export default function RouteSeo() {
  const { pathname } = useLocation();
  const meta = ROUTES[pathname] ?? FALLBACK;
  return <Seo title={meta.title} description={meta.description} noindex={meta.noindex} />;
}
